import React from 'react';
import { Tooltip } from 'fronton-react';
import { Compare } from '@navi-toolbox/ui-components';
import { DATA_QA_PDP_COMPARISON_COMPARE_BUTTON } from './constants';

type CompareButtonWithTooltipProps = {
  active: boolean;
  onClick: () => void;
  buttonText: string;
  tipText: string;
  isDesktop: boolean;
};

export const CompareButtonWithTooltip: React.FC<CompareButtonWithTooltipProps> = ({
  active,
  onClick,
  buttonText,
  tipText,
  isDesktop,
}) => {
  const button = (
    <Compare
      onClick={onClick}
      buttonText={buttonText}
      active={active}
      data-testid={DATA_QA_PDP_COMPARISON_COMPARE_BUTTON}
    />
  );

  return (
    <>
      {isDesktop ? (
        <Tooltip placement="top" title={tipText}>
          {button}
        </Tooltip>
      ) : (
        button
      )}
    </>
  );
};
